import { BrowserRouter as Router } from 'react-router-dom';

import { createBrowserHistory } from 'history';
import Routes from './Routes';
//import './App.css';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from './theme';
import { ControlApp } from './components';

const browserHistory = createBrowserHistory();



const App = () => {

  return (
    <ThemeProvider theme={theme}>
      <ControlApp>
          <Router history={browserHistory}>
            <Routes />
          </Router>
      </ControlApp>
    </ThemeProvider>  
  );
}

export default App;
